import { render, staticRenderFns } from "./openApiList.vue?vue&type=template&id=b2e908f0&scoped=true&"
import script from "./openApiList.vue?vue&type=script&lang=js&"
export * from "./openApiList.vue?vue&type=script&lang=js&"
import style0 from "./openApiList.vue?vue&type=style&index=0&id=b2e908f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e908f0",
  null
  
)

export default component.exports